module.exports = __webpack_public_path__ + "static/media/chalala-01.56fac498.svg";